import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Container,
  Typography,
  CircularProgress,
  Box,
} from "@material-ui/core";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import api from "../../services/api";
import LandingPageEditor from "../../components/LandingPageEditor";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  loading: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "400px",
  },
  error: {
    padding: theme.spacing(3),
    textAlign: "center",
  },
}));

const AdminLandingPage = () => {
  const classes = useStyles();
  const history = useHistory();
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchDraft();
  }, []);

  const fetchDraft = async () => {
    try {
      setLoading(true);
      console.log("Fetching draft from:", `${process.env.REACT_APP_BACKEND_URL}/api/landing-page/draft`);
      const { data } = await api.get("/api/landing-page/draft");
      console.log("Draft data loaded:", data);
      setContent(data);
      setError(null);
    } catch (err) {
      console.error("Error fetching draft:", err);
      console.error("Error response:", err.response);
      console.error("Error status:", err.response?.status);
      console.error("Error data:", err.response?.data);
      setError("Error al cargar el borrador de la landing page");
      toast.error(`Error al cargar el contenido: ${err.response?.data?.error || err.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (updatedContent) => {
    try {
      await api.post("/api/landing-page/draft", updatedContent);
      setContent(updatedContent);
      toast.success("Borrador guardado exitosamente");
    } catch (err) {
      console.error("Error saving draft:", err);
      toast.error("Error al guardar el borrador");
      throw err;
    }
  };

  const handlePublish = async () => {
    try {
      await api.post("/api/landing-page/publish");
      toast.success("Contenido publicado exitosamente");
    } catch (err) {
      console.error("Error publishing:", err);
      toast.error("Error al publicar el contenido");
      throw err;
    }
  };

  const handlePreview = () => {
    window.open("/admin/landing-page/preview", "_blank");
  };

  if (loading) {
    return (
      <Container className={classes.root}>
        <Box className={classes.loading}>
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className={classes.root}>
        <Box className={classes.error}>
          <Typography variant="h6" color="error">
            {error}
          </Typography>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth={false} className={classes.root}>
      <LandingPageEditor
        initialContent={content}
        onSave={handleSave}
        onPublish={handlePublish}
        onPreview={handlePreview}
      />
    </Container>
  );
};

export default AdminLandingPage;
